var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-cell',{attrs:{"title":_vm.$t('运动历史'),"icon":"bar-chart-o","is-link":""},on:{"click":_vm.open}})}
var staticRenderFns = []

export { render, staticRenderFns }